import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@mui/styles";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import Fab from "@mui/material/Fab";
import Typography from "@mui/material/Typography";
import PDFResource from "../utils/PDFResource";
import classNames from "classnames";
import Enums from "../utils/Enums";
import { Document, Page, pdfjs } from "react-pdf";
import util from "../utils/Util";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import zIndex from "@mui/material/styles/zIndex";
import { ConnectingAirportsOutlined, ThreeSixty } from "@mui/icons-material";
import { columnsStateInitializer } from "@mui/x-data-grid/internals";
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";
// You, 2 weeks ago | 6 authors (Cestly Coronado and others)
class PDFViewerBase64 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pages: undefined,
      zoom: 1
    };
    this.route = this.props.route;
    this.downloadPDFRef = null;
    this.downloadCounter = 0;
    
  }
 
  onDocumentComplete = ({ numPages }) => {
    this.setState({ page: 1, pages: numPages, zoom: 1 });
  };
 
  onPageComplete = page => {
    this.setState({ page: page });
  };
 
  handlePreviousPage = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 });
    }
  };
 
  handleNextPage = () => {
    if (this.state.page < this.state.pages) {
      this.setState({ page: this.state.page + 1 });
    }
  };
 
  handleZoomIn = () => {
    if (this.state.zoom < 1.5) {
      this.setState({ zoom: this.state.zoom + 0.1 });
    }
  };
 
  handleZoomOut = () => {
    if (this.state.zoom > 1) {
      this.setState({ zoom: this.state.zoom - 0.1 });
    }
  };
 
  fallbackDownload = (blob, fileName) => {
    
    try {
      // Check if fileName has proper extension
      if (!fileName.toLowerCase().endsWith('.pdf') && !fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
        
        // Force add .pdf extension
        if (blob.type.includes('pdf') || blob.type.includes('application/pdf')) {
          fileName = fileName + '.pdf';
        } else if (blob.type.includes('spreadsheet') || blob.type.includes('excel') || blob.type.includes('vnd.openxmlformats') || blob.type.includes('vnd.ms-excel')) {
          fileName = fileName + '.xlsx';
        }else{
          console.error("unkown Blob type")
          return;
        }
      }

      if(blob.type === '' || blob.type === 'text/plain' || blob.type.includes('text/')){
        console.error("Critical : Blob type is text or empty")
        console.error("Current blob type:" , blob.type);
        alert('Error: invalid file type detected. Download canceolled.')
        return 
      }
      
      const blobUrl = window.URL.createObjectURL(blob);
      
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobUrl;
      tempLink.download = fileName;
      tempLink.target = '_blank';
      
      
      document.body.appendChild(tempLink);
      tempLink.click();
      
      // Cleanup
      setTimeout(() => {
        try{
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl);
        }catch(cleanupError){
          console.error("Cleanup warning:" , cleanupError)
        }
      }, 50);
    } catch (error) {
      console.error("❌ FALLBACK DOWNLOAD ERROR:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      alert('Download failed. Please try again');
    }
  };
 
  // iOS download method - opens PDF in new tab with save instructions
  downloadForIOS = async (blob, fileName) => {
    
    try {
      // Validate fileName extension
      if (!fileName.toLowerCase().endsWith('.pdf') && !fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
        console.error("❌ CRITICAL: iOS download - Filename missing proper extension:", fileName);
        
        // Force add extension based on blob type
        if (blob.type.includes('pdf')) {
          fileName = fileName + '.pdf';
        } else if (blob.type.includes('spreadsheet') || blob.type.includes('excel')) {
          fileName = fileName + '.xlsx';
        }else{
          console.error("X cannont dertermin file type form blob type:", blob.type)
          alert("Error:Unable to determine file type for iOs downlaod")
          return 
        }
      }

      if(blob.type === '' || blob.type === 'text/plain' || blob.type.includes('text/')){
        console.error("Critical ios Download - Invaild blob type :", blob.type);
        alert('Error: Invalid file type detected Download cancelled')
        return 
      }
      
      // Create FileReader to convert blob to base64
      if (navigator.share) {
        try {
          const fileOptions = {
            type: blob.type,
            lastModified: Date.now()
          };
          const file = new File([blob], fileName, fileOptions);
          
          const canShareFile = navigator.canShare({files:[file]});
          
          if(canShareFile){

            await navigator.share({
              files:[file]
            });
            return 
          }else{
            console.error("Cannot share this file object ,using fallback")
          }
        } catch (shareError) {
          console.error("⚠️ Share API error:", shareError);
          console.error("Error name", shareError.name)
          console.error("Error message", shareError.messsage)
        }
      }
 
      // Fallback for iOS - open in new tab
      const blobUrl = window.URL.createObjectURL(blob);

      window.open(blobUrl,'_blank');
      
      setTimeout(() => {
        alert(
          'PDF opened in new tab \n\n' +
          'To save to your device: \n' +
          '1. Tap the share button (square with arrow)\n' +
          '2. Choose a location and tap "save"\n\n' +
          'Or tap and hold the document to get more options'
        );
      }, 800);
 
      setTimeout(() => {
        try{
        // document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
        }catch(cleanupError){
          console.warn("iOS cleanup warning:", cleanupError)
        }
      }, 2000);
    } catch (error) {
      console.error("❌ IOS DOWNLOAD ERROR:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
    }
  };
 
  saveOrOpenBlob = (blob, fileName) => {
    
    try {
      // Critical check for file extension
      if (!fileName.toLowerCase().endsWith('.pdf') && !fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
        console.error("❌ CRITICAL: saveOrOpenBlob - Filename missing proper extension:", fileName);
        console.error("🔴 Blob type:", blob.type);
        
        // Force add extension
        if (blob.type.includes('pdf')) {
          fileName = fileName + '.pdf';
        } else if (blob.type.includes('spreadsheet') || blob.type.includes('excel')) {
          fileName = fileName + '.xlsx';
        } else {
          console.error("❌ Cannot determine file type from blob.type:", blob.type);
          fileName = fileName + '.pdf'; // Default to PDF
        }
      }
      if(blob.type === '' || blob.type === 'text/plain' || blob.type.includes('text')){
        console.error("Critical: saveOrOpenBlob - invalid blob type")
        console.error("Current blob type:" , blob.type);
        alert("Error: Invalid file type. Download cancelled")
        return ;
      }
      const blobUrl = window.URL.createObjectURL(blob);
      
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobUrl;
      tempLink.download = fileName;
     
      
      document.body.appendChild(tempLink);
      tempLink.click();
      
      // Clean up blob URL after a delay
      setTimeout(() => {
        try{
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobUrl);
        }catch(cleanupError){
          console.warn("Cleanup warning ", cleanupError)
        }
      }, 1000);
    } catch (error) {
      console.error("❌ SAVE OR OPEN BLOB ERROR:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Falling back to fallbackDownload...");
      this.fallbackDownload(blob, fileName);
    }
  };
 
  // Main download function
  downloadPDF = async () => {
    this.downloadCounter++ ;
    if(this.downloadCounter >1){
      console.warn(`Warning: downloadPdf called  ${this.downloadCounter} times!`)
    }
    
    try {
      const getPDFBlob = await PDFResource.downloadPDFAsBlob(this.props.pdf);
      
      const blob = getPDFBlob.data;
       
  
 
      if (!getPDFBlob || !getPDFBlob.data) {
        throw new Error("Failed to fetch PDF blob - no data received");
      }
 
      // Ensure blob is proper PDF blob
      if (blob.size === 0) {
        throw new Error("Received empty PDF blob");
      }
      
 
      // Handle download based on device/browser
      if (this.props.fileName) {
        
        // Ensure fileName has .pdf extension
        let fileName = this.props.fileName;
        const isExcelBlob = blob.type.includes('spreadsheet') || blob.type.includes('excel') || blob.type.includes('officedocument')
        const isPDFBlob = blob.type.includes('pdf');

        const hasExcelExt = fileName.toLowerCase().endsWith('.xlsx') || fileName.toLowerCase().endsWith('.xls');
        const hasPDFExt = fileName.toLowerCase().endsWith('.pdf')


        if(isExcelBlob){
          if(!hasExcelExt){
            if(hasPDFExt){
              console.warn("Removing incorrect .pdf extensioin from excel file");
              fileName = fileName.replace(/\.pdf$/i,'');
            }
            fileName = fileName + '.xlsx';
          }
        } else if(isPDFBlob) {
            if(!hasPDFExt){
              if(hasExcelExt){
                console.warn("Removing incorrect Excel extension from PDF file");
                fileName = fileName.replace(/|.(xlsx|xls)$/i,'');
              }
              fileName = fileName + '.pdf';
            }
        }else{
          console.warn("Unknown blob type,defaulting to .pdf");
          if(!hasPDFExt && !hasExcelExt){
            fileName = fileName + '.pdf';
          }
        }
        

        const isIOSDevice = PDFResource.isIOS();
        
        if (isIOSDevice) {
          this.downloadForIOS(blob, fileName);
        } else if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          this.saveOrOpenBlob(blob, fileName);
        }
      } else {
        // No filename provided - open in new tab
        const isIOSDevice = PDFResource.isIOS();
        
        if (isIOSDevice) {
          this.downloadForIOS(blob, 'document.pdf');
        } else {
          // Open in new tab for browsers without filename
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
          }, 1000);
        }
      }
      
    } catch (error) {
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      console.error("Full error object:", error);
 
      alert(`Failed to download PDF: ${error.message}`);
 
      if (this.downloadPDFRef) {
        this.downloadPDFRef.click();
      }
    }
  };
 
  downloadExcel = async () => {
    
    try {
      const response = await PDFResource.downloadPDFAsBlob(this.props.pdf);
      
      const blob = response.data;
 
      // Ensure proper filename with .xlsx extension
      let fileName = this.props.fileName || 'spreadsheet.xlsx';
      
      if (!fileName.toLowerCase().endsWith('.xlsx') && !fileName.toLowerCase().endsWith('.xls')) {
        console.warn("⚠️ Filename missing Excel extension");
        fileName = fileName + '.xlsx';
      }
       
      if(blob.type === '' || blob.type ==='text/plain'){
        fileName = fileName + '.xlsx'
      }

      if(blob.type === '' || blob.type === 'text/plain'){
        alert("Error: Invalid Excel file Download cancelled")
        return 
      }
      
      
      const isIOSDevice = PDFResource.isIOS();
      
      if (isIOSDevice) {
        this.downloadForIOS(blob, fileName);
      } else if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        this.saveOrOpenBlob(blob, fileName);
      }
      
      
    } catch (error) {
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      alert('Failed to download Excel: ' + error.message);
    }
  };
 
  render() {
    const { classes, pdf, pdfContentBase64, isPDF = false } = this.props;
    let type;
    if (pdf)
      if (isPDF) {
        type = Enums.FILE_EXTENSION.PDF;
      } else {
        type = pdf.includes(Enums.FILE_EXTENSION.PDF) ? Enums.FILE_EXTENSION.PDF : Enums.FILE_EXTENSION.OTHERS;
      }
    return (
      <Modal className={classes.pdfViewModal} open={this.props.open} onClose={this.props.handleClose}>
        <div className={classNames(classes.maxWidth, classes.maxHeight)}>
          <Grid className={classes.pdfHolder} container justifyContent="center" spacing={"0px"} tabIndex={-1}>
            {!util.mobile() && <Grid item xs onClick={this.props.handleClose} />}
            <Grid className={classNames(classes.pdfViewHolder)} item xs>
              {this.props.pdf !== undefined &&
                (type === Enums.FILE_EXTENSION.PDF ? (
                  <Document
                    file={`data:application/pdf;base64,${pdfContentBase64}`}
                    onLoadSuccess={this.onDocumentComplete}
                    style={{
                      padding: "50px 0"
                    }}
                  >
                    <Page pageNumber={this.state.page} scale={this.state.zoom} />
                  </Document>
                ) : (
                  <Typography className={classes.temp}>
                    {/* {pdf.split("/").slice(-1)[0]} */}
                    {this.props.fileName}
                    <br />
                    <span className={classes.subTemp}>Preview Unavailable</span>
                  </Typography>
                ))}
              <a onClick={this.props.handleClose} className={classes.closeAction} 
                style={{
                  zIndex:1201,
                }} >
                <Fab>
                  <i className="material-icons">close</i>
                </Fab>
              </a>
              <Fab className={classes.dlAction} onClick={this.downloadPDF} 
                style={{
                  zIndex:1201,
                }} >
                <i className="material-icons">file_download</i>
              </Fab>
            </Grid>
            {!util.mobile() && <Grid item xs onClick={this.props.handleClose} />}
          </Grid>
          {type === Enums.FILE_EXTENSION.PDF && (
            <Grid className={classes.pdfActionsHolder} container justifyContent="center" spacing={"16px"}>
              <Grid item xs={2}>
                <Fab onClick={this.handlePreviousPage} disabled={this.state.page === 1} className={classes.prevAction}>
                  <i className="material-icons">chevron_left</i>
                </Fab>
              </Grid>
              <Grid item xs={2}>
                <Fab
                  onClick={this.handleNextPage}
                  disabled={this.state.page === this.state.pages}
                  className={classes.nextAction}
                >
                  <i className="material-icons">chevron_right</i>
                </Fab>
              </Grid>
              <Grid className={classes.pdfZoomHolder} direction="column" container spacing={"24px"}>
                <Grid item>
                  <Fab className={classes.zoomIn} onClick={this.handleZoomIn} disabled={this.state.zoom >= 1.5}>
                    <i className="material-icons">zoom_in</i>
                  </Fab>
                </Grid>
                <Grid item>
                  <Fab className={classes.zoomOut} onClick={this.handleZoomOut} disabled={this.state.zoom <= 1}>
                    <i className="material-icons">zoom_out</i>
                  </Fab>
                </Grid>
              </Grid>
            </Grid>
          )}
        </div>
      </Modal>
    );
  }
}

const styles = theme => ({
  root: {},
  maxWidth: {
    width: "100%"
  },
  maxHeight: {
    height: "100%"
  },
  heading: {
    paddingTop: 30,
    fontSize: 28,
    color: theme.colors.blackScale.black100
  },
  content: {
    padding: "10px 40px"
  },
  tableHead: {
    backgroundColor: theme.colors.blackScale.black100,
    fontSize: 14,
    padding: 20,
    color: theme.palette.common.white
  },
  tableRowDoc: {
    color: theme.colors.blackScale.black70,
    backgroundColor: "white",
    height: "30px"
  },
  tableCellDoc: {
    padding: 0,
    paddingLeft: 25
  },
  clearCellStyle: {
    padding: 0,
    paddingRight: "0!important",
    border: 0
  },
  pdfViewModal: {
    overflowY: "scroll",
    display : "flex",
    justifyContent: "center"
  },
  dlHolder: {
    textAlign: "right"
  },
  dlIcon: {
    "&:hover": {
      color: theme.colors.blackScale.black80,
      cursor: "pointer"
    },
    color: theme.colors.blackScale.black70
  },
  dlCell: {
    padding: 0
  },
  pdfHolder: {
    height: "100%"
  },
  pdfViewHolder: {
    margin: "20px",
    position: "relative",
    display: "flex",
    flexBasis: "100%",
    "& div": {
      display: "flex",
      justifyContent: "center",
    },
    justifyContent: "center",
  },
  pdfActionsHolder: {
    zIndex: "1000",
    position: "fixed",
    bottom: 20
  },
  centeredNavButtons: {
  position: "fixed",
  bottom: 20,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent:"center",
  gap: "20px",
  zIndex: 1000,
},
  prevAction: {
    float: "right",
    opacity: 0.3,
    "&:hover": {
      opacity: 1
    }
  },
  nextAction: {
    float: "left",
    opacity: 0.3,
    "&:hover": {
      opacity: 1
    }
  },
  closeAction: {
    textDecoration: "none",
    position: "fixed",
    top: 20,
    left: 20,
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
      "&:hover": {
        opacity: 1
      }
    }
  },
  dlAction: {
    position: "fixed",
    top: 20,
    right: 20,
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
      "&:hover": {
        opacity: 1
      }
    }
  },
  pdfZoomHolder: {
    position: "fixed",
    bottom: 20,
    right: 0,
    maxWidth: 100,
    zIndex:1001,
  },
  zoomIn: {
    float: "right",
    marginRight: 20
  },
  zoomOut: {
    float: "right",
    marginRight: 20,
    zIndex:1001
  },
  temp: {
    color: "white",
    textAlign: "center"
  },
  subTemp: {
    color: theme.colors.blackScale.black50,
    fontSize: "1.1em"
  },
  hide: {
    display: "none"
  }
});

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(PDFViewerBase64));
